import { Link } from 'react-router-dom';
import { twoBoxes } from 'src/features/home/components/two-boxes/two-boxes.constants';
import { StyledBoxContainer, StyledBoxWrapper, StyledButton, StyledButtonContainer, StyledDescription, StyledDivider, StyledHeader, StyledImage, StyledImageWrapper, StyledTitle, StyledTwoBoxesWrapper } from 'src/features/home/components/two-boxes/two-boxes.styles';
export const TwoBoxes = () => <StyledTwoBoxesWrapper data-sentry-element="StyledTwoBoxesWrapper" data-sentry-component="TwoBoxes" data-sentry-source-file="two-boxes.tsx">
    {twoBoxes.map(({
    id,
    header,
    title,
    description,
    button,
    image,
    imageHasWrapper,
    link
  }) => <StyledBoxContainer key={id}>
        <StyledBoxWrapper>
          <StyledHeader>{header}</StyledHeader>
          <StyledTitle>{title}</StyledTitle>
          <StyledDivider />
          <StyledDescription>{description}</StyledDescription>
          <StyledButtonContainer>
            <Link to={link}>
              <StyledButton type="submit" color="primary" variant="solid">
                {button}
              </StyledButton>
            </Link>
          </StyledButtonContainer>
        </StyledBoxWrapper>
        <StyledImageWrapper>
          <StyledImage src={image} hasWrapper={imageHasWrapper} alt="CySec training" />
        </StyledImageWrapper>
      </StyledBoxContainer>)}
  </StyledTwoBoxesWrapper>;